import { useState, useEffect } from 'react';

// Les pages utilisent des styles en ligne, sur lesquels les media queries CSS
// n'ont aucune prise. La bascule se fait donc en JS, a partir du meme seuil
// que mobile.css pour que les deux restent coherents.
export const SEUIL_MOBILE = 768;

export default function useEstMobile(seuil = SEUIL_MOBILE) {
  const requete = `(max-width: ${seuil}px)`;
  const [estMobile, setEstMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(requete).matches,
  );

  useEffect(() => {
    const mq = window.matchMedia(requete);
    const surChangement = (e) => setEstMobile(e.matches);
    setEstMobile(mq.matches);
    mq.addEventListener('change', surChangement);
    return () => mq.removeEventListener('change', surChangement);
  }, [requete]);

  return estMobile;
}
